import React from 'react';
import { RallyStateQuery } from '../../graphql-operations';
import { formatRallyFinishTime } from './finish-time';
import { calculateRallyTeamResults, formatRallyTeamAverage } from './team-scoring';

type Entry = NonNullable<RallyStateQuery['rallyState']>['entries'][number];

export default function Results({ entries }: { entries: Entry[] }) {
  const joined = entries.filter((entry) => entry.joined);
  const finishers = joined
    .filter(
      (entry) =>
        entry.progress >= 100 &&
        Boolean(entry.finishedAt) &&
        entry.finishPosition !== null
    )
    .sort((a, b) => (a.finishPosition ?? 999) - (b.finishPosition ?? 999));
  const dnfs = joined.filter((entry) => entry.dnf);
  const teamResults = calculateRallyTeamResults(entries);

  return (
    <main className="rally-results">
      <div className="rally-trophy" aria-hidden="true">
        🦞
      </div>
      <p className="rally-eyebrow">MÅLGÅNG</p>
      <h1>{finishers[0]?.name || 'Ingen gick i mål'}</h1>
      {finishers[0] && (
        <p className="rally-winner-team">Individuell vinnare · {finishers[0].team}</p>
      )}

      <section className="rally-result-card">
        <h2>Individuellt</h2>
        <ol className="rally-order">
          {finishers.map((entry) => (
            <li key={entry.id}>
              <span className="rally-place">{entry.finishPosition}</span>
              <span
                className="rally-result-dot"
                style={{ background: entry.teamColor }}
              />
              <strong>{entry.name}</strong>
              <small>
                {entry.team} · {formatRallyFinishTime(entry.finishTimeSeconds)}
              </small>
            </li>
          ))}
          {dnfs.map((entry) => (
            <li key={entry.id}>
              <span className="rally-place">—</span>
              <span
                className="rally-result-dot"
                style={{ background: entry.teamColor }}
              />
              <strong>{entry.name}</strong>
              <small>{entry.team} · Bröt loppet</small>
            </li>
          ))}
        </ol>
      </section>

      <section className="rally-result-card">
        <h2>Lagresultat</h2>
        <p className="rally-scoring-note">Snittplacering · lägst vinner.</p>
        <ol className="rally-team-order">
          {teamResults.map((team) => (
            <li key={team.name}>
              <span>{team.rank}</span>
              <i style={{ background: team.color }} />
              <strong>{team.name}</strong>
              <b>{formatRallyTeamAverage(team.averagePosition)}</b>
            </li>
          ))}
        </ol>
      </section>
    </main>
  );
}
